var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewElavtor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.806,
    height: 21.5,
    viewBox: "0 0 21.806 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50011",
    "data-name": "Group 50011",
    transform: "translate(-1444.25 7839.75)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93822",
    "data-name": "Path 93822",
    d: "M11.065,22H5.626A3.631,3.631,0,0,1,2,18.364V5.636A3.631,3.631,0,0,1,5.626,2h9.065a3.631,3.631,0,0,1,3.626,3.636V12",
    transform: "translate(1443 -7841)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_622",
    "data-name": "Line 622",
    x2: 2.55,
    y2: 2.646,
    transform: "translate(1457.427 -7822.573)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_623",
    "data-name": "Line 623",
    x1: 5,
    y2: 6,
    transform: "translate(1460 -7825.927)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_624",
    "data-name": "Line 624",
    x2: 5,
    transform: "translate(1449.951 -7834.037)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_625",
    "data-name": "Line 625",
    x2: 4,
    transform: "translate(1449.949 -7830.007)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_626",
    "data-name": "Line 626",
    x2: 2.477,
    transform: "translate(1449.949 -7825.978)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewElavtor);
export default __webpack_public_path__ + "static/media/Interview_elavtor.818deebee0d499e492e9351619dca470.svg";
export { ForwardRef as ReactComponent };